<template>
 <div>
 <b-container class="container">
    <b-card-group deck>
      <b-card v-for="(sponsor,index) in $parent.event.sponsors"
        title="" sub-title="" class="event_card">
        <div>
          <img :src="sponsor.logo" @click="openimg(sponsor.url)"
             class="sponsorimg"/>
        </div>
        <div>
          {{ sponsor.name }}
        </div>
      </b-card>
    </b-card-group>
  </b-container>
 </div>
</template>

<script>

import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";

export default {
  name: "sponsors",
  data() {
    return {
    }
  },
  components: {
  },
  created() {
  },
  methods: {
    openimg: function(url) {
        console.log("url:"+url);
        if (url != '') {
            if (!url.match(/^https?:\/\//i)) {
                url = 'http://' + url;
                }
            window.open(url, '_blank');
        }
    },
  },
  computed: {
  },
  beforeDestroy() {
  },
  mounted() {
    $("body").removeClass("setbackground");
    let vue = this;
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 60rem;
}
.event_card {
  min-width: 15rem;
  max-width: 20rem;
  min-height: 10rem;
  margin-top: 10px;
  border:none;
}
.date_time {
  font-size:1.2rem;
  font-weight:500;
  text-align:left;
  color:black;
  padding-bottom: 1rem;
}
.para {
  white-space: pre-wrap;
}
.sponsorimg {
  width: 80px;
  height: 80px;
  cursor: pointer;
}
.land_title {
  font-size:1.8rem;
  font-weight:500;
  text-align:left;
  color:black;
  padding-bottom: 0.5rem;
} 
</style>
